import { ButtonHTMLAttributes } from 'react'

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost'
}

export function Button({ variant = 'primary', className = '', ...props }: Props) {
  const base = 'inline-flex items-center justify-center rounded h-10 px-4 text-sm transition-colors disabled:opacity-50'
  const variants: Record<NonNullable<Props['variant']>, string> = {
    primary: 'bg-primary text-primary-foreground hover:opacity-95',
    secondary: 'bg-secondary text-foreground hover:opacity-95',
    outline: 'border hover:bg-secondary',
    ghost: 'hover:bg-secondary'
  }
  return <button className={`${base} ${variants[variant]} ${className}`} {...props} />
}

